import buildCanvasQueryKey from './buildCanvasQueryKey';
import invalidateCanvasLists from './invalidateCanvasLists';
import type { InvalidateCanvasGraphParams } from '../types';

// An item write can shift the item list, the connection list (server cascades
// connection deletion when an item is removed) and the canvas doc's
// item/connection counts, and it logs an activity event (item_added/removed/
// description_updated). It also changes the counts shown on the list cards, so
// the item/connection/canvas/activity reads plus every list query are
// invalidated together.
const invalidateCanvasGraph = ({
    queryClient,
    organizationId,
    canvasId,
}: InvalidateCanvasGraphParams): Promise<void> => {
    const affectedKeys = [
        buildCanvasQueryKey({ scope: 'items', canvasId }),
        buildCanvasQueryKey({ scope: 'connections', canvasId }),
        buildCanvasQueryKey({ scope: 'canvas', canvasId }),
        buildCanvasQueryKey({ scope: 'activity', canvasId }),
    ];

    return Promise.all([
        queryClient.invalidateQueries({
            predicate: query =>
                typeof query.queryKey === 'string' && affectedKeys.includes(query.queryKey),
        }),
        invalidateCanvasLists({ queryClient, organizationId }),
    ]).then(() => undefined);
};

export default invalidateCanvasGraph;
